import { useOutletContext } from "react-router-dom";
import Overview from "../components/Overview";
import { CreativeReport, CreativeReportSection } from "../types";
import { ISidebarItem } from "@/components/common/sidebar/SidebarItem";
import { Dispatch, SetStateAction } from "react";
import { TZDate } from "@date-fns/tz";

interface OutletContext {
  reportConfig: CreativeReport | null;
  setReportConfig: Dispatch<SetStateAction<CreativeReport | null>>;
  reportConfigLoading: boolean;
  reportConfigError: boolean;
  selectedSection: (CreativeReportSection & { overrideScroll?: boolean }) | null;
  setSelectedSection: (
    section: (CreativeReportSection & { overrideScroll?: boolean }) | null,
  ) => void;
  handleAddSection: () => Promise<void>;
  isAddingSection: boolean;
  allowedDateRange: {
    first_allowed_date: TZDate;
    last_allowed_date: TZDate;
  } | null;
  isAccountSynced: boolean;
  hideAddSectionButton?: boolean;
  selectedSidebarItem: ISidebarItem | null;
  isChatOpen: boolean;
  setIsChatOpen: (open: boolean) => void;
}

const OverviewRoute = () => {
  const {
    reportConfig,
    reportConfigLoading,
    reportConfigError,
    allowedDateRange,
    isChatOpen,
    setIsChatOpen,
  } = useOutletContext<OutletContext>();

  return (
    <Overview
      reportConfig={reportConfig}
      reportConfigLoading={reportConfigLoading}
      isChatOpen={isChatOpen}
      setIsChatOpen={setIsChatOpen}
      reportConfigError={reportConfigError}
      allowedDateRange={allowedDateRange}
    />
  );
};

export default OverviewRoute;
